import type { SidebarPageMatch } from '@/analytics/context/pageRegistry';

const APP_NAME = 'OptoScale';
const SEPARATOR = ' • ';

type Translate = (key: string) => string;

/**
 * Builds the browser tab title, most specific first: `Growth • Weight • OptoScale`.
 * Pages without a sidebar entry get the app name alone.
 */
export function buildDocumentTitle(match: SidebarPageMatch | null, t: Translate): string {
    if (!match) {
        return APP_NAME;
    }

    const labels = [match.subItem, match.moduleItem]
        .map((item) => (item ? t(item.label).trim() : ''))
        .filter((label, index, all) => label !== '' && label !== all[index - 1]);

    return [...labels, APP_NAME].join(SEPARATOR);
}

/** The tab title of a page that names itself rather than its route: `Page not found • OptoScale`. */
export function buildPageDocumentTitle(label: string): string {
    return [label, APP_NAME].join(SEPARATOR);
}
